;(function () {
	const initSection = (section) => {
		if (!section.classList.contains('tslider-section-wrapper')) return;

		const track = section.querySelector('.tslider__track');
		const prevBtn = section.querySelector('.tslider__arrow--prev');
		const nextBtn = section.querySelector('.tslider__arrow--next');

		if (!track) return;

		const swiper = new Swiper(track, {
			loop: false,
			speed: 500,
			watchSlidesProgress: true,
			breakpoints: {
				320: {
					slidesPerView: 1,
					spaceBetween: 24,
				},
				750: {
					slidesPerView: 2,
					spaceBetween: 48,
				},
				990: {
					slidesPerView: 2,
					spaceBetween: 64,
				},
			},
			navigation: {
				prevEl: prevBtn,
				nextEl: nextBtn,
			},
			on: {
				init: (sw) => updateArrows(sw, prevBtn, nextBtn),
				slideChange: (sw) => updateArrows(sw, prevBtn, nextBtn),
			},
		});
	};

	const updateArrows = (swiper, prevBtn, nextBtn) => {
		if (!prevBtn || !nextBtn) return;

		if (swiper.isBeginning) {
			prevBtn.classList.add('is-disabled');
		} else {
			prevBtn.classList.remove('is-disabled');
		}

		if (swiper.isEnd) {
			nextBtn.classList.add('is-disabled');
		} else {
			nextBtn.classList.remove('is-disabled');
		}
	};

	initSection(document.currentScript.parentElement);

	document.addEventListener('shopify:section:load', (e) => {
		initSection(e.target);
	});
})();
